import React from "react"
import * as styles from "./icon.module.css"

type IconProps = {
  /**
   * The ID of the icon to display. This should correspond to a CSS class in `icon.module.css` that defines the icon's appearance.
   *
   * @example "cross"
   * @example "readOnly"
   */
  id:
    | "readOnly"
    | "writeOnly"
    | "edit"
    | "required"
    | "googleCloud"
    | "gcp"
    | "azure"
    | "aws"
    | "shield"
    | "warn"
    | "external"
    | "tick"
    | "cross"
    | "thumb-down"
    | "deprecated"
    | "coin"
    | "coinDark"
    | "capSmall"
    | "capMedium"
    | "capLarge"
    | "labs"
    | "info"
    | "decisionTree"
    | "recommendation"
    | "video"
    | "price"
    | "currency-usd"
    | "notify"
    | "close"

  /**
   * Optional tooltip text to display when hovering over the icon.
   */
  tip?: string

  /**
   * If true, the icon will not change appearance in dark mode.
   * Default is false, meaning the icon may adapt to dark mode if styles are defined for it.
   */
  noDarkMode?: boolean
}

const Icon: React.FC<IconProps> = ({ id, tip, noDarkMode = false }) => (
  <i className={styles[id]} data-no-dark-mode={noDarkMode} data-tip={tip} />
)

export default Icon
